import * as styles from "./Buttons.scss";
import { SimpleComponent } from "./SimpleComponent";

export class Buttons extends SimpleComponent {
    protected tag = "div";
    protected className = styles.buttons;
}
